import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CrmInteractionRating } from "@enums/crmInteractionRating.enum";
import { InteractionType } from "@enums/interactionType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { CrmContact } from "@interfaces/models/crmContact.interface";
import { CrmEvent } from "@interfaces/models/crmEvent.interface";
import { CrmInteraction } from "@interfaces/models/crmInteraction.interface";
import { CrmLead } from "@interfaces/models/crmLead.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AuthService } from "@services/auth.service";
import { CrmContactService } from "@services/crmContact.service";
import { CrmEventService } from "@services/crmEvent.service";
import { CrmInteractionService } from "@services/crmInteraction.service";
import { CrmLeadService } from "@services/crmLead.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "crm-interactions-id",
	styleUrls: ["crmInteractions-id.css"],
	templateUrl: "crmInteractions-id.html"
})
export class CrmInteractionIdAdminComponent {
	contacts: CrmContact[] = [];
	events: CrmEvent[] = [];
	headerPrimaryButtons: AdminHeaderButton[] = [];
	interactionTypes: any[] = [];
	item: CrmInteraction = new CrmInteraction();
	itemId = 0;
	itemType = "CRM Interaction";
	leads: CrmLead[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title: string = "View " + this.itemType;
	userProfile: UserProfile = new UserProfile();
	userProfiles: UserProfile[] = [];

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: CrmInteractionService, private crmLeadService: CrmLeadService, private crmContactService: CrmContactService, private crmEventService: CrmEventService, private userProfileService: UserProfileService, private authService: AuthService) {
		this.interactionTypes = GetPropertiesFromEnum(InteractionType);
		this.buildButtons("view");
		this.route.params.subscribe((params) => {
			if (params.id !== "create") {
				if (params.id.split("_").length > 1) {
					this.itemId = params.id.split("_")[0];
					this.getItem(this.itemId);
					this.edit();
				} else {
					this.itemId = params.id;
					this.getItem(params.id);
				}
			} else {
				this.item.interactionDate = new Date();
				this.create();
			}
		});
		this.getContacts();
		this.getEvents();
		this.getLeads();
		this.getUserProfile();
		this.getUserProfiles();
	}

	buildButtons(mode: string) {
		if (mode === "edit") {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode === "create") {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save Interaction" },
				{ method: "close", text: "Close" }
			];
		} else {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
		this.getItem(this.itemId);
	}

	close() { this.router.navigate([this.returnUrl]); }

	create() {
		this.readOnly = false;
		this.title = "New " + this.itemType;
		this.buildButtons("create");
	}

	createItem() {
		this.item.instigatorId = this.userProfile.id;
		this.itemService.createSingle(this.item).subscribe(
			(res: any) => { this.toastService.success("Interaction saved!"); this.router.navigate([`${this.returnUrl}/${res.response.id}`]); },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	edit() {
		this.readOnly = false;
		this.title = "Edit " + this.itemType;
		this.buildButtons("edit");
	}

	getContacts() { this.crmContactService.getAll().subscribe((res: any) => { this.contacts = (res.response.items || []).map((c: any) => ({ ...c, fullName: ((c.firstName || "") + " " + (c.lastName || "")).trim() })); }); }
	getEvents() { this.crmEventService.getAll().subscribe((res: any) => { this.events = res.response.items; }); }
	getItem(id: any) {
		this.itemService.getSingleById(id).subscribe(
			(res: any) => { this.item = res.response; },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	getLeads() { this.crmLeadService.getAll().subscribe((res: any) => { this.leads = (res.response.items || []).filter((l: any) => l.isActive); }); }

	getRatingEmoji(rating: CrmInteractionRating | undefined): string {
		if (rating === CrmInteractionRating.Positive) return "😊";
		if (rating === CrmInteractionRating.Neutral) return "😐";
		if (rating === CrmInteractionRating.Negative) return "😞";
		return "—";
	}
	getUserProfile() {
		this.authService.getCurrentUserProfile().subscribe(
			(res: any) => { this.userProfile = res.response; },
			(err) => { console.log(err); }
		);
	}

	getUserProfiles() { this.userProfileService.getAll().subscribe((res: any) => { this.userProfiles = res.response.items; }); }

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	setFollowUpDays(days: number) {
		const d = new Date();
		d.setDate(d.getDate() + days);
		this.item.followUpDate = d;
	}

	setFollowUpWeeks(weeks: number) {
		const d = new Date();
		d.setDate(d.getDate() + weeks * 7);
		this.item.followUpDate = d;
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item).subscribe(
			() => { this.toastService.success("Interaction updated!"); this.cancelEditing(); },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}
}
